<template>
  <main>
    <b-card class="mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold py-3">
          گزارش افرادی که از دیجی پی خرید کردن
        </h5>
        <div style="flex:1"></div>

        <button
          class="btn btn-info btn-sm"
          @click="showTable('showTablePlaceOrders', 'showTableGetCredit')"
        >
          گزارش ثبت سفارش
        </button>
        <!-- <button class="btn btn-warning btn-sm mr-2" @click="showTable('showTableGetCredit','showTablePlaceOrders')">گزارش دریافت اعتبار</button> -->
      </div>
      <div class="card-body mt-5">
        <form
          autocomplete="chrome-off"
          class="mb-5 pb-5"
          @submit.prevent="submitFilter"
        >
          <div class="row align-items-center">
            <div class="col-4">
              <DatePickerRange v-model="filter.date" />
            </div>
            <button
              :disabled="disabled"
              type="submit"
              class="btn btn-primary px-5"
            >
              فیلتر
            </button>
          </div>
        </form>
        <div v-if="reportDashboard" class="row ">
          <div class="col-md-6 col-xl-3">
            <b-card>
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-muted mb-0">
                    افرادی که اس ام اس براشون ارسال شده
                  </h5>
                  <span class="d-table h4 font-weight-bold p-6">
                    <!-- {{
                    reportDashboard.buy_count | price
                  }} -->
                    (از کاوه نگار پیگیری شود)
                  </span>
                </div>
                <div class="col-auto">
                  <div class="rounded-circle shadow bg-gradient-success ">
                    <i
                      class="fe fe-message-circle text-white p-4"
                      style="font-size: x-large;"
                    ></i>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
          <div
            class="col-md-6 col-xl-3"
            v-if="reportDashboard.clicked_on_banner"
          >
            <b-card>
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-muted mb-0">
                    افرادی که روی لینک کلیک کردن
                  </h5>
                  <span class="d-table h2 font-weight-bold p-5">{{
                    reportDashboard.clicked_on_banner.toLocaleString()
                  }}</span>
                </div>
                <div class="col-auto">
                  <div class="rounded-circle shadow bg-gradient-warning ">
                    <i
                      class="fe fe-users text-white p-4"
                      style="font-size: x-large;"
                    ></i>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
          <div
            class="col-md-6 col-xl-3"
            v-if="reportDashboard.buy_from_digipay_count"
          >
            <b-card
              @click="showTable('showTablePlaceOrders')"
              style="cursor: pointer;"
            >
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-muted mb-0">
                    افرادی که سفارش ثبت کردن
                  </h5>
                  <span class="d-table h2 font-weight-bold p-5">{{
                    reportDashboard.buy_from_digipay_count.toLocaleString()
                  }}</span>
                </div>
                <div class="col-auto">
                  <div class="rounded-circle shadow bg-gradient-success ">
                    <i
                      class=" fa fa-credit-card text-white p-4"
                      style="font-size: x-large;"
                    ></i>
                  </div>
                </div>
              </div>
            </b-card>
          </div>

          <div class="col-md-6 col-xl-3">
            <b-card>
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-muted mb-0">
                    افرادی که اعتبار دریافت کردن
                  </h5>
                  <span class="d-table h2 font-weight-bold p-5">-</span>
                </div>
                <div class="col-auto">
                  <div class="rounded-circle shadow bg-gradient-primary">
                    <i
                      class="fa fa-credit-card text-white p-4"
                      style="font-size: x-large;"
                    ></i>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
          <div
            class="col-md-6 col-xl-3"
            v-if="reportDashboard.visit_landing_page"
          >
            <b-card>
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-muted mb-0">
                    افرادی که از صفحه لندینگ بازدید کردن
                  </h5>
                  <span class="d-table h2 font-weight-bold p-5">{{
                    reportDashboard.visit_landing_page.toLocaleString()
                  }}</span>
                </div>
                <div class="col-auto">
                  <div class="rounded-circle shadow bg-gradient-warning">
                    <i
                      class="fe fe-eye text-white p-4"
                      style="font-size: x-large;"
                    ></i>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>
        <div v-else class="alert alert-primary">در حال بارگزاری</div>
      </div>
    </b-card>
    <b-card class="mt-3" v-if="showTableItem.showTablePlaceOrders">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold py-3">
          افرادی که سفارش ثبت کردن
        </h5>
        <div style="flex:1"></div>
      </div>
      <div class="card-body">
        <b-table
          v-if="placeOrders && placeOrders.data"
          bordered
          striped
          :fields="placeOrdersfields"
          :items="placeOrders.data"
          responsive="sm"
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(order_id)="data">
            <router-link :to="`/admin/order/${data.item.id}`">{{
              data.item.id
            }}</router-link>
          </template>
          <template v-slot:cell(customer)="data">
            <router-link
              :to="`/admin/customers/show/${data.item.customer.id}`"
              >{{
                data.item.customer.first_name || data.item.customer.last_name
                  ? data.item.customer.first_name +
                    " " +
                    data.item.customer.last_name
                  : data.item.customer.mobile
              }}</router-link
            >
          </template>
          <template v-slot:cell(total_amount)="data">
            {{ data.item.total_amount | price }}
          </template>
          <template v-slot:cell(status)="data">
            <order-status :status="data.item.status"></order-status>
          </template>
          <template #bottom-row="data">
            <b-td colspan="4">جمع کل:</b-td>
            <b-td>{{ totals.sum_order_amount | price }}</b-td>
          </template>
        </b-table>
        <div v-else class="alert alert-primary">در حال بارگزاری</div>
        <pagination
          v-if="placeOrders && placeOrders.data != ''"
          :router="true"
          :disabled="disabled"
          :limit="2"
          :data="placeOrders"
          @pagination-change-page="changePagePlaceOrders"
        />
      </div>
    </b-card>
    <!-- <b-card class="mt-3" v-if="showTableItem.showTableGetCredit">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold py-3">
          افرادی که اعتبار دریافت کردند
        </h5>
        <div style="flex:1"></div>
      </div>
      <div class="card-body" >
        <b-table
          id="main-table"
          v-if="getCredits && getCredits.data"
          bordered
          striped
          :fields="getCreditsfields"
          :items="getCredits.data"
          responsive="sm"
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(order_id)="data">
            <router-link :to="`/admin/order/${data.item.id}`">{{ data.item.id }}</router-link>
          </template>
          <template v-slot:cell(customer)="data">
            <router-link :to="`/admin/customers/show/${data.item.customer.id}`">{{ (data.item.customer.first_name||data.item.customer.last_name)?data.item.customer.first_name+" "+data.item.customer.last_name:data.item.customer.mobile }}</router-link>
          </template>
          <template v-slot:cell(total_amount)="data">
            {{ data.item.total_amount | price }}
          </template>
          <template v-slot:cell(status)="data">
            <order-status :status="data.item.status"></order-status>
          </template>
        </b-table>
        <div v-else class="alert alert-primary">در حال بارگزاری</div>
        <pagination
          v-if="getCredits && getCredits.data != ''"
          :router="true"
          :disabled="disabled"
          :limit="2"
          :data="getCredits"
          @pagination-change-page="changePageGetCredits"
        />
      </div>
      </b-card> -->
  </main>
</template>
<script>
import {
  BTable,
  BFormGroup,
  BFormInput,
  BTd,
  BCollapse,
  VBToggle,
  VBTooltip,
  BButton,
  BCard,
} from "bootstrap-vue";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import OrderStatus from "@@/core/components/order/OrderStatus/OrderStatus";

class Filter {
  constructor() {
    // this.search = null;
    this.date = {
      startDate: "",
      endDate: "",
    };
  }
  set(filters) {
    console.log(filters);

    Object.entries(filters).forEach(([index, value]) => {
      this[index] = value;
    });
  }
}

export default {
  components: {
    BTable,
    DatePickerRange,
    BFormGroup,
    BTd,
    BFormInput,
    BCollapse,
    VBToggle,
    VBTooltip,
    BButton,
    OrderStatus,
    BCard,
  },
  data() {
    return {
      placeOrdersfields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "order_id",
          label: "شناسه سفارش",
        },
        {
          key: "customer",
          label: "کاربر",
        },
        {
          key: "status",
          label: "وضعیت سفارش",
        },
        {
          key: "items_quantity",
          label: "تعداد آیتم ها",
        },
        {
          key: "total_amount",
          label: "مبلغ سفارش",
        },
      ],
      getCreditsfields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "order_id",
          label: "شناسه سفارش",
        },
        {
          key: "customer",
          label: "کاربر",
        },
        {
          key: "total_amount",
          label: "مبلغ سفارش",
        },
        {
          key: "status",
          label: "وضعیت سفارش",
        },
      ],
      totalRows: 0,
      per_page: 0,
      currentPage: 1,
      previousPage: 1,
      sortBy: null,
      sortDesc: null,
      filter: new Filter(),
      appliedFilter: new Filter(),
      disabled: false,
      reportDashboard: null,
      placeOrders: null,
      totals: null,
      getCredits: null,

      showTableItem: {
        showTablePlaceOrders: false,
        showTableGetCredit: false,
      },
    };
  },
  created() {
    // this.loadData();
  },

  methods: {
    showTable(keyTrue, keyFalse) {
      this.showTableItem[keyTrue] = true;
      this.showTableItem[keyFalse] = false;
    },
    async loadData() {
      try {
        this.disabled = true;
        this.appliedFilter.set(this.filter);
        const response = await this.$axios.get("admin/reports/digipay-flash", {
          params: {
            from_date: this.appliedFilter.date.startDate,
            to_date: this.appliedFilter.date.endDate,
            // customer_id: this.appliedFilter.search,
            page: this.currentPage,
          },
        });
        this.perPage = response.data.data.orders.per_page;
        this.reportDashboard = response.data.data;
        this.placeOrders = response.data.data.orders;
        this.totals = response.data.data.totals;
      } catch (error) {
        this.$root.notify(error);
      } finally {
        this.disabled = false;
      }
    },
    submitFilter() {
      this.loadData();
    },
    changePagePlaceOrders(page = 1) {
      this.previousPage = this.currentPage;
      this.currentPage = page;
      this.loadData();
    },
    changePageGetCredits(page = 1) {
      this.previousPage = this.currentPage;
      this.currentPage = page;
      this.loadData();
    },
  },
  watch: {
    per_page() {
      this.changePage(1);
    },
  },
};
</script>
<style scoped>
main .card {
  min-height: unset;
}
</style>
